<template>
    <div class="page courses-page py-2 py-lg-6">
        <v-container :class="{'pa-0': phoneOnly}">
            <v-card class="pa-0 transparent" flat>
                <v-card-text class="py-lg-2 py-0" :class="{'px-0': phoneOnly}">
                    <template v-if="!loading || hasContent">
                        <div v-if="packages && packages.length" class="mb-4 mb-lg-8">
                            <v-subheader v-if="phoneOnly" class="mt-2">باقاتي</v-subheader>
                            <div v-if="pcOnly" class="mb-3">
                                <div class="strong-text--text" style="font-size: 1.25rem">باقاتي</div>
                                <div class="muted--text details-text mt-1">الباقات التي قمت بالاشتراك فيها</div>
                            </div>
                            <v-row v-if="pcOnly">
                                <v-col cols="12" md="6" lg="3" v-for="(pkg, i) in packages" :key="'pkg-' + pkg.id + '-' + i" class="d-flex px-0 px-md-2 py-2">
                                    <package-card :pkg="pkg" @updated="loadData" />
                                </v-col>
                            </v-row>
                            <v-list v-else two-line class="pa-0">
                                <package-list-item
                                    v-for="(pkg, i) in packages"
                                    :key="'pkg-list-' + pkg.id + '-' + i"
                                    :pkg="pkg"
                                    @updated="loadData"
                                />
                            </v-list>
                        </div>

                        <div v-if="courses && courses.length">
                            <v-subheader v-if="phoneOnly && packages && packages.length" class="mt-2">دوراتي</v-subheader>
                            <div v-if="pcOnly && packages && packages.length" class="mb-3">
                                <div class="strong-text--text" style="font-size: 1.25rem">دوراتي</div>
                                <div class="muted--text details-text mt-1">قائمة الدورات التي انضممت لها</div>
                            </div>
                            <v-row v-if="pcOnly">
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in courses" :key="course.id + '-' + i" class="d-flex px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                            <v-list v-else two-line class="pa-0">
                                <course-list-item v-for="(course, i) in courses" :key="course.id + '-' + i" :course="course" />
                            </v-list>
                        </div>

                        <div v-else-if="!packages || !packages.length" class="pa-4 pa-lg-0">
                            <v-alert outlined color="blue-grey" text type="info">لم تنضم إلى أي دورة حتى اﻵن</v-alert>
                        </div>
                    </template>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'
import PackageCard from '@/components/custom/package-card'
import PackageListItem from '@/components/custom/package-list-item'

export default {
    name: "Courses",
    components: {
        CourseCard,
        CourseListItem,
        PackageCard,
        PackageListItem,
    },
    data(){
        return {
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        courses(){
            return this.$store.state.coursesModule.myCourses;
        },
        packages(){
            return this.$store.state.coursesModule.myPackages;
        },
        hasContent(){
            return (this.courses && this.courses.length) || (this.packages && this.packages.length);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getMyCourses').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted(){
        this.loadData();
    }
};
</script>

<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>
